import { useSelector } from "react-redux";
import { UTMCampaign, UTMContent, UTMMedium, UTMSource, UTMTerm } from "./components";
import { UTMOverall } from "./components";
import { selectLogInUsername } from "../../common/authenticateDashboard/authSlice";
import { useEffect, useState } from "react";


const MarketingPerformance = () => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  // const [isRockwell, setRockwell] = useState(false)
  
  // useEffect(() => {
  //   if (!user) return;
  //   if (user?.includes('getrockwell-prod')) setRockwell(true);
  // }, [user])


  return (
    <div className="flex-grow" style={{ width: "75%" }}>
      <div className="my-3 p-3 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <UTMSource />
            <UTMMedium />
            <UTMCampaign />
            <UTMContent />
            <UTMTerm/>
           <UTMOverall />
        </div>
      </div>
    </div>
  );
};

export default MarketingPerformance;
